import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import earring from '../../../../../Assets/adore-imgs/collection/earring.jpg'
import eng from '../../../../../Assets/adore-imgs/collection/eng-ring.jpg'
import neck from '../../../../../Assets/adore-imgs/collection/neck.jpg'
import wedding from '../../../../../Assets/adore-imgs/collection/wedding.jpg'
import bracelets from '../../../../../Assets/adore-imgs/collection/bracelets.jpg'
import left from '../../../../../Assets/adore-imgs/left-arrow.png'
import right from '../../../../../Assets/adore-imgs/right-arrow.png'
import Slider from "react-slick";
import { BsArrowRight } from "react-icons/bs";
// Helper function for image paths
const getImagePath = (filename) => `${ImageUrl}theme/showcase/${filename}`;

const collections = [
  { name: "Rings", image: eng, path: "/jewelry/fashion-rings" },
  { name: "Bracelets", image: bracelets, path: "/jewelry/bracelets" },
  { name: "Earrings", image:earring, path: "/jewelry/earrings" },
  { name: "Necklaces", image: neck, path: "/jewelry/necklaces" },
  { name: "Wedding", image: wedding, path: "/jewelry/wedding-rings" },
];

const ExploreCollection = () => {
   var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: <img src={left} alt="left arrow" />,
    nextArrow: <img src={right} alt="right arrow" />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px',
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <section className="explore-collection">
      <Container fluid >
        <Heading>
          <h2>Explore Our Collection</h2>
          {/* <p>Explore {Je_welryspelling} Collections by Style and Make a Statement.</p> */}
        </Heading>

        <Row>
       
             <Slider {...settings} className="overflow-hidden">
           {collections.map(({ name, path, image }) => (
        <div className="collection_item_outer_box">
           <div className="item text-left">
                <Link to={path} className="img-box" aria-label={`Shop ${name}`}>
                  <Image src={image} alt={name} loading="lazy" />
                </Link>
                <Link to={path}>{name}</Link>
                   <button to={path} className="shop_now_btn">Shop Now <BsArrowRight /></button>
              </div>
        </div>
                 ))}
      </Slider>
        </Row>
      </Container>
    </section>
  );
};

export default ExploreCollection;
